<ng-container [formGroup]="formGroup">
  <div class="app-phoneNumber mt-1" [class.loading-field]="countryLoading || loading">
    <div class="input-group" [ngClass]="{'field-error': hasError('required') || hasError('invalid')}"
      (focusout)="isTouched = true">

      <div class="input-group-prepend w-70">
        <!-- appendTo="body" -->
          <ng-select [items]="countryList" [disabled]="disabled"
              [(ngModel)]="phoneCountryId" bindLabel="name"
              bindValue="id"
              [ngModelOptions]="{standalone: true}"
              (change)="phoneValueChanged($event)"
              (ngModelChange)="setFieldControlValue()" >
              <ng-template ng-label-tmp let-item="item">
                <!-- <div class="flag-selected" [innerHTML]="item.countryFlag | sanitizeHtml"></div> -->
                <div class="flag-selected"><img [src]="item.countryFlag" alt=""></div>
                {{item.countryKey }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <!-- <span class="flag-list" [innerHTML]="item.countryFlag | sanitizeHtml"></span> -->
                <span class="flag-list"><img [src]="item.countryFlag" alt=""></span>
                {{item.name}}
                <span class="grey-color">{{item.countryKey }}</span>
              </ng-template>
          </ng-select>
      </div>


      <input type="tel" class="form-control" [placeholder]="label"
          [(ngModel)]="phoneNumberValue"
          [ngModelOptions]="{standalone: true}"
          (ngModelChange)="setFieldControlValue(); modelChanged()"
          (change)="phoneValueChanged($event)"
          (keydown.enter)="phoneValueChanged($event)"
          appOnlynumber [required]="required" [disabled]="disabled">

      <input type="hidden" *ngIf="controlName" [formControlName]='controlName'>
      <input type="hidden" *ngIf="!controlName">
    </div>
    <p class="custom-error" *ngIf="hasError('required')" [class.active]="hasError('required')">
        {{ 'forms.Required' | translate }}
    </p>
    <p class="custom-error" *ngIf="phoneNumberValue && hasError('invalid')"
        [class.active]="phoneNumberValue && hasError('invalid')">
        {{ 'forms.Invalid value' | translate }}
    </p>
  </div>

</ng-container>
